import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  createPlanSuccess() {},
  createPlanFailed() {},
  createEventSuccess() {},
  createEventFailed() {},
  updateEventSuccess() {},
  updateEventFailed() {},
  deleteEventSuccess() {},
  deleteEventFailed() {},
  getPlanSuccess(state, payload) {
    state.currentPlan = payload.plan;
  },
  updatePlanSuccess(state, payload) {
    state.currentPlan = Object.assign({}, state.currentPlan, {
      ...payload.plan
    });
  },
  getCompetitorEmbeddedSuccess(state, payload) {
    const newCompetitorEmbeddeds = [...state.competitorEmbeddeds];
    const index = newCompetitorEmbeddeds.findIndex(competitor => {
      return competitor.id === payload.competitor.id;
    });
    if (index > -1) {
      newCompetitorEmbeddeds[index] = payload.competitor;
    } else {
      newCompetitorEmbeddeds.push(payload.competitor);
    }
    state.competitorEmbeddeds = newCompetitorEmbeddeds;
  },
  getCompetitorEmbeddedFailed(state, payload) {
    const newCompetitorErrors = [...state.competitorErrors];
    const index = newCompetitorErrors.findIndex(competitor => {
      return competitor.companyId === payload.error.companyId;
    });
    if (index > -1) {
      newCompetitorErrors[index] = payload.error;
    } else {
      newCompetitorErrors.push(payload.error);
    }
    state.competitorErrors = newCompetitorErrors;
  },
  getStudentEmbeddedSuccess(state, payload) {
    const newStudentEmbeddeds = [...state.studentEmbeddeds];
    const index = newStudentEmbeddeds.findIndex(student => {
      return student.id === payload.student.id;
    });
    if (index > -1) {
      newStudentEmbeddeds[index] = payload.student;
    } else {
      newStudentEmbeddeds.push(payload.student);
    }
    state.studentEmbeddeds = newStudentEmbeddeds;
  },
  getStudentEmbeddedFailed(state, payload) {
    const newStudentErrors = [...state.studentErrors];
    const index = newStudentErrors.findIndex(student => {
      return student.studentId === payload.error.studentId;
    });
    if (index > -1) {
      newStudentErrors[index] = payload.error;
    } else {
      newStudentErrors.push(payload.error);
    }
    state.studentErrors = newStudentErrors;
  },
  getStudentJobHuntingTrendCollectionSuccess(state, payload) {
    state.studentJobHuntingTrendCollection =
      payload.studentJobHuntingTrendCollection;
  },
  resetStudentJobHuntingTrendCollection(state) {
    state.studentJobHuntingTrendCollection = undefined;
  },
  createCompetitorSuccess(state, payload) {
    if (!state.currentPlan) {
      return;
    }
    const newCurrentPlant = { ...state.currentPlan };
    newCurrentPlant.competitors.unshift(payload.competitor);
    state.currentPlan = newCurrentPlant;
  },
  createCompetitorFailed(state, payload) {
    state.competitorErrors.push(payload.error);
  },
  deleteCompetitorSuccess(state, payload) {
    state.competitorEmbeddeds = state.competitorEmbeddeds.filter(competitor => {
      return competitor.id !== payload.competitorId;
    });
  },
  deleteUniversitySuccess(state, payload) {
    state.studentEmbeddeds = state.studentEmbeddeds.filter(student => {
      return student.id !== payload.studentId;
    });
  },
  createUniversitySuccess(state, payload) {
    if (!state.currentPlan) {
      return;
    }
    const newCurrentPlant = { ...state.currentPlan };
    newCurrentPlant.student_segments.unshift(payload.university);
    state.currentPlan = newCurrentPlant;
  },
  updateUniversitySuccess(state, payload) {
    if (!state.currentPlan) {
      return;
    }

    state.isUpdateUniversity = true;

    const newStudentSegments = state.currentPlan.student_segments.map(
      student_segment =>
        student_segment.id === payload.university.id
          ? payload.university
          : student_segment
    );

    const newCurrentPlan = {
      ...state.currentPlan,
      student_segments: newStudentSegments
    };

    state.currentPlan = newCurrentPlan;
  },
  resetIsUpdateUniversity(state) {
    state.isUpdateUniversity = false;
  }
};

export default mutations;
